import React, { useState } from 'react';
import classNames from 'classnames';
import {
    Box,
    Theme,
    Button,
    Dialog,
    Typography,
    ModalProps,
    ButtonProps,
    DialogTitle,
    DialogActions,
    DialogContent,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { ButtonLoader } from '../material/Index';

type ModalWithoutChildrenProps = Omit<ModalProps, 'children'>;
interface ModalBasicProps {
    modalProps: ModalWithoutChildrenProps;
    buttonConfirmProps?: ButtonProps;
    buttonCancelProps?: ButtonProps;
    title: string;
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: '50px',
    },
    buttons: {
        display: 'flex',
        fontSize: '2.5rem',
        minWidth: 250,
        padding: '20px 10px',
    },
    buttonCircularProgress: {
        color: 'inherit',
    },
    title: {
        color: theme.palette.primary.main,
        textAlign: 'center',
    },
    content: {
        fontSize: '1.5rem',
        fontFamily: 'Altice',
        textAlign: 'center',
        fontWeight: 400,
        lineHeight: 1.33,
        marginBottom: 12,
    },
    actionsLayer: {
        marginTop: '20px',
        justifyContent: 'space-between',
    },
}));

const BasicModal: React.FC<ModalBasicProps> = (props) => {
    const {
        title,
        children,
        modalProps,
        buttonCancelProps,
        buttonConfirmProps,
    } = props;

    const classes = useStyles();

    const [confirmLoading, setConfirmLoading] = useState(false);

    return (
        <Dialog {...modalProps} classes={{ paper: classes.root }}>
            <DialogTitle>
                <Typography  className={classes.title} variant='h4' align='center' color='primary'>
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent className={classes.content}>
                {children}
            </DialogContent>
            <DialogActions className={classes.actionsLayer}>
                <Button
                    variant='secondary'
                    {...buttonCancelProps}
                    className={classes.buttons}
                >
                    <Typography variant='button' align='center'>
                        <Box>{buttonCancelProps?.name}</Box>
                    </Typography>
                </Button>
                <ButtonLoader
                    variant='primary'
                    submitting={confirmLoading}
                    CircularProgressProps={{
                        className: classes.buttonCircularProgress,
                    }}
                    {...buttonConfirmProps}
                    onClick={(e) => {
                        let promise = Promise.resolve();

                        setConfirmLoading(true);

                        if (buttonConfirmProps?.onClick) {
                            promise = promise.then(() =>
                                buttonConfirmProps.onClick?.(e)
                            );
                        }

                        promise.finally(() => setConfirmLoading(false));
                    }}
                    className={classNames(classes.buttons)}
                >
                    <Typography variant='button' align='center'>
                        <Box>{buttonConfirmProps?.name}</Box>
                    </Typography>
                </ButtonLoader>
            </DialogActions>
        </Dialog>
    );
};

export default BasicModal;
